import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import DeductionList, { DispatchProps, OwnProps, StateProps } from './DeductionList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getDeductions } from 'src/store/actions/deduction-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.deductions.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getDeductions(params)),
    };
}

const DeductionListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(DeductionList);

export default DeductionListScreen;
